import { Component, Element } from "@stencil/core";
import { ErrorResponseWrapper } from "@apis/errors/error-response-wrapper";
import config from "../../../environment/environment-config";
import state, { getStockData, getPriceData } from "@stores/price.store";

@Component({
  tag: "bcp-fetch-price-data",
  styleUrl: "bcp-fetch-price-data.scss",
})
export class FetchPriceData {
  @Element() el: HTMLBcpFetchPriceDataElement;

  componentWillLoad() {
    const pricesProductIds = this.getProductIds("bcp-price");
    const stocksProductIds = this.getProductIds("bcp-stock");

    if (stocksProductIds?.length) {
      const productIds = Array.from(new Set(stocksProductIds));
      const stockTimeoutController = new AbortController();
      const stockTimeoutId = setTimeout(
        () => stockTimeoutController.abort(),
        config?.pricesConfig?.timeout ?? 5000
      );
      state.set("loadingStocks", true);
      getStockData(productIds, stockTimeoutController.signal)
        .then((stocks) => {
          state.set("stocks", stocks);
        })
        .catch((response) => {
          this.isAborted(response)
            ? state.set("timeoutStocks", true)
            : this.handleErrors(response);
          state.set("stocksFailed", true);
        })
        .finally(() => {
          state.set("loadingStocks", false);
          clearTimeout(stockTimeoutId);
        });
    }

    if (pricesProductIds.length) {
      const productIds = Array.from(new Set(pricesProductIds));
      const priceTimeoutController = new AbortController();
      const priceTimeoutId = setTimeout(
        () => priceTimeoutController.abort(),
        config?.pricesConfig?.timeout ?? 5000
      );
      state.set("loadingPrices", true);
      getPriceData(productIds, priceTimeoutController.signal)
        .then((prices) => {
          state.set("prices", prices);
        })
        .catch((response) => {
          this.isAborted(response)
            ? state.set("timeoutPrices", true)
            : this.handleErrors(response);
        })
        .finally(() => {
          state.set("loadingPrices", false);
          clearTimeout(priceTimeoutId);
        });
    }
  }

  private getProductIds(tagName) {
    return Array.from(this.el.querySelectorAll(tagName))?.map(
      (el) => el.productId
    );
  }

  handleErrors = async (error: ErrorResponseWrapper) => {
    const errors = await (error as ErrorResponseWrapper)?.getErrorMessages();
    state.set("errors", errors ?? ["Error"]);
  };

  isAborted(response) {
    return (
      response?.code == 20 ||
      response?.name === "AbortError" ||
      response?.message === "Aborted"
    );
  }
}
